import { useState } from 'react'

import { useIncidentImageSelect } from './useIncidentImageSelect'
import { useToasts } from '@/hooks/useToasts'
import {
  UPLOAD_ERROR_COMPONENTS,
  reportUploadError,
  useUpload,
} from '@/hooks/useUpload'
import { UploadError } from '@/hooks/useUpload/error'

import { UploadedFileType } from '@/graphql/generated/schemas'

export const useIncidentImageUpload = () => {
  const { selectedFiles, handleFileSelect, removeFile, clearFiles } =
    useIncidentImageSelect()
  const [upload] = useUpload()
  const [isUploading, setIsUploading] = useState(false)
  const { showError } = useToasts()

  const uploadImages = async (): Promise<string[]> => {
    if (selectedFiles.length === 0) return []

    setIsUploading(true)
    try {
      const uploadPromises = selectedFiles.map((file) =>
        upload({
          file,
          fileType: UploadedFileType.IncidentImage,
        })
      )
      return await Promise.all(uploadPromises)
    } catch (error) {
      reportUploadError(error, UPLOAD_ERROR_COMPONENTS.IncidentImageUpload)
      showError(
        error instanceof UploadError ? error.message : 'Failed to upload images'
      )
      throw error
    } finally {
      setIsUploading(false)
    }
  }

  return {
    selectedFiles,
    handleFileSelect,
    removeFile,
    clearFiles,
    uploadImages,
    isUploading,
  }
}
